// import { axiosInstance } from '../api_manager/Axios'

const baseURL = useRuntimeConfig().public.baseURL;

export const getStudentCourses = async (status) => {
  try {
    const response =  await fetch(`${baseURL}/api/individuals/user_courses_list/?status=${status}`);
    return response.json()
  } catch (error) {
    console.error('Error fetching beneficiaries:', error)
    throw error
  }
}